<script>
// Barras verticais (equalizador) — usado no menu do composer do Chat IA pra
// marcar o Modo de Voz (ao lado do `microphone.vue`, que virou o ícone do
// Ditar) e, com `animado`, como o próprio indicador de "gravando" no botão
// de Parar — substitui o componente `composer-voz-bars` separado que existia
// antes: [feedback do usuário, 04/09] "a animação ao falar deveria partir do
// ÍCONE novo, com ele se mexendo", não de barras à parte do ícone.
//
// Nativo: sem equivalente `mdi-` que combine com o traço dos outros ícones
// do menu, e a animação por barra exige controle individual que um ícone de
// fonte não dá.
export default {
  name: 'AudioLinesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
    // Pulso contínuo por barra, com atraso escalonado — o mesmo idioma de
    // `.iv2-dot-pulsante`/`.iv2-cursor-digitando` (design/efeitos.sass):
    // decorativo, não amostrado do RMS real quadro a quadro (custaria
    // re-render por frame só pelo ícone). Respeita `prefers-reduced-motion`.
    animado: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="{ 'audio-lines-icon--animado': animado }"
  >
    <rect
      class="audio-lines-icon__bar audio-lines-icon__bar--1"
      x="1.5"
      y="7"
      width="3"
      height="10"
      rx="1.5"
      :fill="color"
    />
    <rect
      class="audio-lines-icon__bar audio-lines-icon__bar--2"
      x="7.5"
      y="3"
      width="3"
      height="18"
      rx="1.5"
      :fill="color"
    />
    <rect
      class="audio-lines-icon__bar audio-lines-icon__bar--3"
      x="13.5"
      y="5"
      width="3"
      height="14"
      rx="1.5"
      :fill="color"
    />
    <rect
      class="audio-lines-icon__bar audio-lines-icon__bar--4"
      x="19.5"
      y="8"
      width="3"
      height="8"
      rx="1.5"
      :fill="color"
    />
  </svg>
</template>

<style lang="sass" scoped>
.audio-lines-icon--animado .audio-lines-icon__bar
  transform-origin: center
  animation: audioLinesPulse 0.9s ease-in-out infinite

  &--1
    animation-delay: 0s
  &--2
    animation-delay: 0.15s
  &--3
    animation-delay: 0.3s
  &--4
    animation-delay: 0.45s

@keyframes audioLinesPulse
  0%, 100%
    transform: scaleY(0.45)
  50%
    transform: scaleY(1)

@media (prefers-reduced-motion: reduce)
  .audio-lines-icon--animado .audio-lines-icon__bar
    animation: none
</style>
